import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Grid,
  Typography,
} from '@mui/material';
import React from 'react';

interface CardTypes {
  price: number;
  img: string;
  city: string;
  description: string;
}
const FlatCard: React.FC<CardTypes> = ({ price, img, city, description }) => {
  return (
    <Card sx={{ maxWidth: 580, display: 'flex', marginTop: '25px' }}>
      <CardMedia
        component="img"
        sx={{
          objectFit: 'cover',
          flex: '1 0 auto',
          width: '50%',
          maxHeight: '100%',
        }}
        image={img}
        alt="green iguana"
      />
      <Grid container direction="column" justifyContent="space-between">
        <Grid item>
          <CardContent>
            <Typography gutterBottom variant="h5" component="div">
              ${price} / night
            </Typography>
            <Typography variant="h6" component="div">
              {city}
            </Typography>
            <Typography
              sx={{
                display: '-webkit-box',
                overflow: 'hidden',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: 3,
              }}
              variant="body2"
              color="text.secondary"
            >
              {description}
            </Typography>
          </CardContent>
        </Grid>
        <Grid item>
          <CardActions>
            <Button color="primary">Details</Button>
          </CardActions>
        </Grid>
      </Grid>
    </Card>
  );
};

export default FlatCard;
